import React from "react";

// Lightweight image component that uses native lazy loading and async decoding.
// Accepts src (string or module require), alt, className, srcSet, sizes, and style.
const LazyImage = ({ src, alt = "", className = "", srcSet, sizes, style }) => {
  // If src is a module (result of require), allow it directly.
  const srcValue = src && src.default ? src.default : src;

  return (
    <img
      src={srcValue}
      alt={alt}
      className={className}
      loading="lazy"
      decoding="async"
      srcSet={srcSet}
      sizes={sizes}
      style={style}
    />
  );
};

export default LazyImage;
